module.exports = __webpack_public_path__ + "img/profile.61857b24.svg";